/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { DebtorsAnalysisComponent } from "@src/app/modules/txn/debtors-analysis/debtors-analysis.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const DebtorsAnalysisNavRoute = new NavRoute('debtorsAnalysisList', ()=>DebtorsAnalysisComponent, 'analytics').setViews(() => {
    return [
        {
            id: 'analysis',
            name: 'Analysis of outstanding monies',
            helpText: 'Analysis of outstanding monies owed by unit owners',
            filterFields: {
                analysisOnly: 'true'
            }
        }
    ]
});
